import Icon from '../components/Icon.vue'

Icon.register({
  gavel: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M505 199.4c9.4 9.4 9.4 24.6 0 33.9l-124.5 124.5c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l5.7-5.7-39.6-39.6-81 81 5.7 5.7c12.5 12.5 12.5 32.8 0 45.3l-114.7 114.7c-12.5 12.5-32.8 12.5-45.3 0l-45.3-45.3c-12.5-12.5-12.5-32.8 0-45.3l114.7-114.7c12.5-12.5 32.8-12.5 45.3 0l5.7 5.7 81-81-39.6-39.6-5.7 5.7c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l124.5-124.5c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-5.7 5.7 113.1 113.1 5.7-5.7c9.4-9.4 24.6-9.4 33.9 0z'
      }
    ]
  }
})
